import { render, staticRenderFns } from "./TicketsMonitoring.vue?vue&type=template&id=278465f2&scoped=true"
import script from "./TicketsMonitoring.vue?vue&type=script&lang=js"
export * from "./TicketsMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278465f2",
  null
  
)

export default component.exports